import { WktInfo } from "@abaco/map-web-module/src/modules/map-web-module/LayerBuilder";
import { Plot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";
import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import {
    ConfiguredStep,
    CustomStepLot,
    CustomStepLotParams,
    ProcessedRecipe,
    Recipe,
    StepObjectCode
} from "./models/PrecisionModel";
export default class PrecisionVuexModule extends AbacoVuexModule {
    @State({ default: [] }) selectedPlots!: Plot[];
    @State({ default: [] }) selectedAreas!: WktInfo[];
    @State() selectedArea!: WktInfo;
    @State({ default: 1 }) currentStep!: number;
    @State() currentStepCode!: StepObjectCode;
    @State({ default: {} }) configuredSteps!: ConfiguredStep;
    @State({ default: [] }) customAreas!: WktInfo[];
    @State({ default: {} }) currentRecipe!: Recipe;
    @State({ default: [] }) recipes!: Recipe[];
    @State({ default: false }) bypassValidation!: boolean;
    @State({ default: null }) curTileButtonHighlighted!: string | null;
    @State({ default: [] }) externalAlgorithms!: Algorithm[] | null;
    @State({ default: true }) algorithmStepValid!: boolean;
    @State({ default: [] }) processedRecipes!: ProcessedRecipe[];
    @State({ default: null }) pickValue!: { value: number; loading: boolean } | null;
    @State() pickingCalculationId!: number;
    @State() pdfMapImg!: [number, string]; //base 64 img of the map. Necessary for print pdf in PrecisionReciepeAction. Img is associated with calculationId
    @State() selectedLot!: CustomStepLot | null;
    @State({ default: {} }) customStepLotParams!: Record<number, CustomStepLotParams>;
    @State() canLoadRaster!: boolean;
    @State({ default: 4326 }) shpSrid!: number;
    @State({ default: true }) createShp!: boolean;
}
